import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class AccountProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'users'

  me() {
    return this.submit('get', `${this.endpoint}/me`)
  }
}
